/* /training/tool-intros — Hub page showing all 12 tool-intro mini lessons.
   Click a card → /training/tool-intros/:slug → plays the kinetic lesson. */
import { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import { TOOL_INTROS } from "../data/toolIntros";
import { Play, Clock } from "lucide-react";

const G   = "#2E9F3A";
const O   = "#F39A1F";
const RED = "#C9202E";
const INK = "#0F172A";
const SKY = "#E0F2FE";

export default function ToolIntrosHubPage() {
  useEffect(() => {
    document.title = "Tool Intros — Faitharama Mini Training";
  }, []);
  return (
    <div className="min-h-screen bg-white">
      <SiteNav />

      <section style={{ background: SKY }} className="py-12 md:py-16 border-b-2" >
        <div className="max-w-6xl mx-auto px-5 md:px-8 text-center">
          <div className="text-[10px] tracking-[0.32em] uppercase font-bold mb-3" style={{ color: RED }}>
            ★ FAITHARAMA MINI TRAINING
          </div>
          <h1 className="font-serif-display uppercase leading-[0.98]"
              style={{ color: INK, fontSize: "clamp(2.25rem, 5vw, 3.75rem)" }}>
            12 Tools. <span style={{ color: G }}>12 Three-Minute Lessons.</span>
          </h1>
          <p className="text-lg md:text-xl mt-5 max-w-2xl mx-auto" style={{ color: INK }}>
            One quick intro for every builder on Faitharama. Mike on camera. Big headlines on screen. Watch the one you need, when you need it.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {TOOL_INTROS.map((t) => (
              <Link
                key={t.slug}
                to={`/training/tool-intros/${t.slug}`}
                data-testid={`tool-intro-card-${t.slug}`}
                className="group rounded-2xl overflow-hidden bg-white shadow-md hover:shadow-2xl hover:-translate-y-1 transition border-2"
                style={{ borderColor: t.color }}
              >
                {/* Top color band with play icon */}
                <div
                  className="relative aspect-video flex items-center justify-center"
                  style={{ background: `linear-gradient(135deg, ${t.color} 0%, ${INK} 130%)` }}
                >
                  <div className="absolute top-3 left-3 text-white/90 text-[10px] tracking-[0.22em] uppercase font-bold">
                    Lesson #{t.n}
                  </div>
                  <div className="absolute top-3 right-3 flex items-center gap-1 text-white/90 text-[10px] tracking-[0.18em] uppercase font-bold">
                    <Clock className="w-3 h-3" /> 3 min
                  </div>

                  <div className="w-16 h-16 rounded-full bg-white/15 backdrop-blur flex items-center justify-center group-hover:scale-110 group-hover:bg-white/25 transition">
                    <Play className="w-7 h-7 text-white ml-0.5" />
                  </div>

                  <div className="absolute bottom-3 left-3 right-3 text-white text-center font-serif-display uppercase text-xl md:text-2xl leading-tight"
                       style={{ textShadow: "0 2px 12px rgba(0,0,0,0.45)" }}>
                    {t.name}
                  </div>
                </div>

                {/* Tagline */}
                <div className="p-5">
                  <p className="text-base md:text-[15px] leading-relaxed" style={{ color: INK }}>
                    {t.tagline}
                  </p>
                  <div className="mt-3 text-[11px] uppercase tracking-[0.18em] font-bold flex items-center gap-1" style={{ color: t.color }}>
                    Watch Now <Play className="w-3 h-3" />
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <p className="mt-10 text-center italic" style={{ color: INK, opacity: 0.7 }}>
            New lessons added every quarter. Same format. Same Mike.
          </p>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
